import React, { Component } from 'react';
import TimeRange from './TimeRange';
import Balance from "./Balance";

export default class Header extends Component {
    onTimeRangeChange(newValue) {
        this.props.onTimeRangeChange(newValue);
    }
    render() {
        const style = {
            header: {
                position: 'fixed',
                top: 42,
                left: 0,
                right: 0,
                height: 80,
                backgroundColor: '#FFF',
                borderBottom: '1px solid #EEE'
            },
            h1: {
                fontFamily: 'Merriweather',
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                width: 160,
                padding: 30,
                fontSize: 24,
                fontWeight: 600,
                color: '#414255'
            }
        };
        return (
            <header style={style.header}>
                <h1 style={style.h1}>Moneylist</h1>
                <TimeRange daysInFuture={this.props.daysInFuture} onChange={this.onTimeRangeChange.bind(this)} />
                <Balance amount={this.props.balance} onClick={this.props.onBalanceClick.bind(this)} />
            </header>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Header.js